import React, { useEffect } from 'react'; // 1. Make sure useEffect is imported
import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from '../ui/WhatsAppFloat';
import ChatBot from '../ui/ChatBot';

const Layout = () => {
  const location = useLocation();

  // --- 2. ADD THIS USEEFFECT HOOK ---
  // This hook will run every time the page URL (location.pathname) changes.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 }
  };

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.5
  };

  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-dark-50 transition-colors duration-300">
      <Navbar />
      <main className="flex-grow pt-16 lg:pt-20">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
      <WhatsAppFloat />
      <ChatBot />
    </div>
  );
};

export default Layout;